/**
 * Phone breakpoint for the playlist stats modal, mirroring the Radix `sm`
 * breakpoint its responsive props use.
 *
 * Keep in sync with the `--phone` custom media query in
 * `PlaylistStats.module.css`: media queries can't read a JS constant or a CSS
 * custom property, so this is the one value that has to exist in both places.
 */
export const PHONE_BREAKPOINT_PX = 768
